import { Component, OnInit, inject, input } from '@angular/core';
import { CustomLinks } from '../../shared/interfaces/research-portal/portal-configuration/homepage-configuration.interface';
import { PortalService } from '../portal.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { MatAnchor } from '@angular/material/button';


@Component({
    selector: 'esp-portal-free-links',
    templateUrl: './portal-free-links.component.html',
    styleUrls: ['./portal-free-links.component.scss'],
    imports: [
        MatAnchor,
        MatIcon,
        TranslateModule
    ]
})
export class PortalFreeLinksComponent implements OnInit {
    private portalService = inject(PortalService);

    readonly customLinks = input<CustomLinks>(undefined);
    readonly sectionNumber = input(undefined);

    links = [];

    ngOnInit(): void {
        const customLinks = this.customLinks();
        this.links.push(customLinks?.firstLink);
        this.portalService
            .getHomepageLinkImage(this.sectionNumber() * 2 - 1)
            .subscribe((data) => {
                this.customLinks().firstLink.imageUrl = data as string;
            });
        if (customLinks?.includeSecondLink) {
            this.links.push(customLinks?.secondLink);
            this.portalService
                .getHomepageLinkImage(this.sectionNumber() * 2)
                .subscribe((data) => {
                    this.customLinks().secondLink.imageUrl = data as string;
                });
        }
    }

    getLinkTitle(i) {
        return (
            'research.portal.homepage.custom_link_title_0' +
            this.sectionNumber() +
            '_0' +
            parseInt(i + 1)
        );
    }

    getLinkText(i) {
        return (
            'research.portal.homepage.custom_link_text_0' +
            this.sectionNumber() +
            '_0' +
            parseInt(i + 1)
        );
    }
}
